import validator from 'validator';

export default {
  name: 'ChangePassword',
  props: {
    userDetails: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      passwordRepeated: '',
      user: {
        password: '',
      },
      rules: {
        password: [{ required: true, validator: this.__validatePassword, trigger: 'change' }],
        passwordRepeated: [{
          required: true,
          validator: this.__validatePasswordRepeated,
          trigger: 'change',
        }],
      },
    };
  },
  computed: {
    isLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'user/updateUser',
      ]);
    },
  },
  methods: {
    async submitForm() {
      const userData = this.$refs.userForm;
      const userParams = this.$refs.userForm.model;
      userData.validate(async (valid) => {
        if (valid) {
          let params = {};
          if (userParams.password.length !== 0) {
            params = {
              user: this.userDetails.user_uuid,
              password: userParams.password,
            };
          }
          const result = await this.$store.dispatch('user/updateUser', params);
          if(result.status == 200) {
            location.reload();
          }
        }
      });
    },
    __validatePassword(rule, value, callback) {
      if (!validator.isLength(value, { min: 8 })) {
        callback('Hasło nie może być krótsze niż 8 znaków.');
        return;
      }
      if (value.replace(/[^A-Z]/g, '').length === 0) {
        callback('Hasło musi posiadać przynajmniej 1 wielką literę.');
        return;
      }
      if (value.replace(/[^0-9]/g, '').length === 0) {
        callback('Hasło musi posiadać przynajmniej 1 cyfrę.');
        return;
      }
      callback();
    },
    __validatePasswordRepeated(rule, value, callback) {
      if (this.user.password.length !== this.passwordRepeated.length) {
        callback('Podane hasła muszą być takie same');
        return;
      } if (this.user.password !== this.passwordRepeated) {
        callback('Podane hasła muszą być takie same');
        return;
      }
      callback();
    },
  },
};
